import { ThunderboltFilled, ThunderboltOutlined } from "@ant-design/icons";
import styled, { css } from "styled-components";

export const StyledFlashButton = styled.button<{
    $on: boolean;
    $supported: boolean;
}>`
    top: 16px;
    left: 16px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition:
        background 0.2s ease,
        transform 0.18s cubic-bezier(0.34, 1.56, 0.64, 1),
        opacity 0.2s;

    opacity: ${({ $supported }) => ($supported ? 1 : 0.35)};
    pointer-events: ${({ $supported }) => ($supported ? "auto" : "none")};

    ${({ theme, $on }) =>
        $on
            ? css`
                  background: ${theme.colors.yellowAccent};
                  box-shadow: 0 2px 16px ${theme.colors.yellowAccent}73;
                  transform: scale(1.08);

                  animation: flashPulse 0.6s ease;

                  @keyframes flashPulse {
                      0% {
                          box-shadow: 0 0 0 0 ${theme.colors.yellowAccent}99;
                      }
                      70% {
                          box-shadow: 0 0 0 10px ${theme.colors.yellowAccent}00;
                      }
                      100% {
                          box-shadow: 0 0 0 0 ${theme.colors.yellowAccent}00;
                      }
                  }
              `
            : css`
                  background: ${theme.primaryBackground}ad;
                  backdrop-filter: blur(14px);
                  -webkit-backdrop-filter: blur(14px);

                  &:hover {
                      background: ${theme.secondaryBackgroundColor}cc;
                      transform: scale(1.06);
                  }
                  &:active {
                      transform: scale(0.94);
                  }
              `}
`;

export const StyledFlashIconOn = styled(ThunderboltFilled)`
    font-size: 20px;
    color: ${({ theme }) => theme.colors.black};
`;

export const StyledFlashIconOff = styled(ThunderboltOutlined)`
    font-size: 20px;
    color: ${({ theme }) => theme.secondaryTypographyColor};
`;
